import { Button, Image, Popover, Tag } from "antd";
import {
  deleteCompanyFieldsById,
  updateCompanyFieldsById,
} from "../../ducks/services";
import { SuccessMessage } from "../../../../../atoms/Toasts/SuccessMessage";
import { getCompanyFieldsById } from "../../ducks/actions";
import { AxiosError } from "axios";
import { ErrorMessage } from "../../../../../atoms/Toasts/ErrorMessage";
import { useAppDispatch } from "../../../../../config/hooks";
import TagPopOver from "../TagPopOver";
import { useState } from "react";

interface PropsType {
  item: {
    id: string;
    name: string;
    color?: string;
  };
  companyId: string;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  moduleName: string;
  changeColor?: boolean;
}

export default function TagsList(props: PropsType) {
  const { item, companyId, setLoading, moduleName, changeColor } = props;
  const dispatch = useAppDispatch();
  const [open, setOpen] = useState(false);

  const createTag = (
    moduleName: string,
    tagName: string,
    colorName: string,
    id?: string
  ) => {
    setLoading(true);
    const payload = {
      id: id ? id : undefined,
      company_id: companyId,
      module: moduleName,
      name: tagName,
      value: tagName?.replace(/ /g, "_"),
      color: colorName,
    };

    updateCompanyFieldsById(payload)
      .then(() => {
        setLoading(false);
        SuccessMessage("Tag updated");

        setOpen(false);

        const payload = {
          company_id: companyId,
        };

        dispatch(getCompanyFieldsById(payload));
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          setLoading(false);
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
        } else {
          setLoading(false);
          ErrorMessage("Something went wrong");
        }
      });
  };

  const deleteTag = (id: string) => {
    setLoading(true);

    deleteCompanyFieldsById(id)
      .then(() => {
        setLoading(false);
        SuccessMessage("Tag deleted");
        setOpen(false);
        const payload = {
          company_id: companyId,
        };

        dispatch(getCompanyFieldsById(payload));
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          setLoading(false);
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
        } else {
          setLoading(false);
          ErrorMessage("Something went wrong");
        }
      });
  };

  const handleOpenChange = (newOpen: boolean) => {
    setOpen(newOpen);
  };

  return (
    <div className="tags_list">
      <Tag className={`${item?.color}`} bordered={item?.color ? false : true}>
        {item?.name}
      </Tag>
      <Popover
        arrow={false}
        content={
          <TagPopOver
            item={item}
            createTag={createTag}
            deleteTag={deleteTag}
            moduleName={moduleName}
            changeColor={changeColor}
          />
        }
        trigger="click"
        open={open}
        onOpenChange={handleOpenChange}
        placement="bottomRight"
        getPopupContainer={(trigger) => trigger.parentElement || document.body}
      >
        <Button
          onClick={(e) => {
            e.stopPropagation();
          }}
          onKeyDown={(e) => e.stopPropagation()}
          className="only_icon"
          icon={<Image src="/images/table/more-dots.svg" preview={false} />}
        />
      </Popover>
    </div>
  );
}
